/**
 * ======================================
 * download
 * author: sky-sky
 * file: download.js
 * date: 2023/09/27 11:22
 * ======================================
 */
export function downloadContacts() {
  console.log("下载通讯录导入模板");
  window.open("/download/通讯录导入模板.xlsx");
}

export function formatFileSize(size) {
  if (size === 0) return "0 B";
  if (!size) return "--";
  const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const k = 1024;
  const i = Math.floor(Math.log(size) / Math.log(k));
  return parseFloat((size / Math.pow(k, i)).toFixed(2)) + " " + units[i];
}

export function download(url, name = "file") {
  let link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.click();
}

export function downloadCsv(data, filename) {
  console.log("data,filename", data, filename);
  const csv = data.map((row) => row.join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();

  URL.revokeObjectURL(url);
}
